<template>
  <div class="relative" v-if="data">
    <ServiceHero
      v-if="data.title && data.hero"
      :title="data.title"
      :hero="data.hero"
    ></ServiceHero>
    <h2 class="text-center text-header-xl pt-12 pb-4">
      {{ data.intro.title }}
    </h2>
    <div
      class="sticky top-20 z-1 bg-transparent hidden md:flex flex-wrap items-center justify-center gap-4 py-2"
    >
      <NuxtLink
        v-for="item in data.intro.labels"
        :aria-label="item.text"
        :to="`${item.to}`"
      >
        <Button
          variant="ghost"
          size="sm"
          class="rounded-full bg-white shadow-md border-[1px] border-foreground/70 px-4 py-1"
        >
          {{ item.text }}
        </Button>
      </NuxtLink>
    </div>
    <p class="container mx-auto text-center py-8 text-foreground/80">
      {{ data.intro.description }}
    </p>
    <section
      v-if="data.summaryCards"
      class="flex flex-wrap items-center justify-center gap-8 pt-16"
    >
      <div v-for="item in data.summaryCards" class="summary-card">
        <NuxtPicture
          :src="item.src"
          :alt="item.text"
          format="svg"
          height="84px"
          width="84px"
          class="mx-auto mb-4"
        ></NuxtPicture>
        <h3 class="text-center text-base">{{ item.text }}</h3>
      </div>
    </section>
    <CallToAction
      v-if="data.callToAction"
      v-bind="data.callToAction"
    ></CallToAction>
    <template v-if="data.components && data.components.length > 0">
      <template v-for="component in data.components" :key="component.id">
        <div>
          <component
            :is="component.type"
            :id="component.id"
            v-bind="component.props"
          ></component>
        </div>
      </template>
    </template>
    <BuildSomethingSection id="build-with-us"></BuildSomethingSection>
  </div>
  <NotFound v-else></NotFound>
</template>

<script setup lang="ts">
import ServiceHero from "~/components/base/Services/ServiceHero.vue";
import { loadPageData } from "~/lib/pages";

const $route = useRoute();
let data: any = null;
if ($route.params.id && typeof $route.params.id === "string")
  data = loadPageData($route.params.id);

useSeoMeta({
  title: ["CAT", data?.title].join(" | "),
});

useHead({
  title: data?.title ?? "CAT | Services",
  meta: [
    {
      name: "description",
      content: data?.description,
    },
  ],
});

const resolve = (component: string) => {
  return resolveComponent(component);
};
</script>

<style scoped lang="scss">
.summary-card {
  @apply flex flex-col flex-none h-56 w-56 items-center justify-center gap-4 rounded-md bg-white hover:scale-105 transform duration-500 p-4;
  box-shadow: 0px 16px 32px rgba(0, 122, 255, 0.1), inset 0px 0px 1px #007aff;
}
</style>
